<!-- <div class="ie-panel"> -->
<!-- <a href="http://windows.microsoft.com/en-US/internet-explorer/"><img src="../../assets/images/ie8-panel/warning_bar_0000_us.jpg" height="42" width="820" alt="You are using an outdated browser. For a faster, safer browsing experience, upgrade for free today."></a> -->
<!-- </div> -->

<div class="page animated">
    <section class="section breadcrumbs-custom">
        <div class="breadcrumbs-custom-main bg-image bg-primary">
            <div class="container">
                <h3 *ngIf="!authService.isValidCompany" class="breadcrumbs-custom-title">Ολοκλήρωση Προφίλ Εταιρείας
                </h3>
                <h3 *ngIf="authService.isValidCompany" class="breadcrumbs-custom-title">Επεξεργασία Προφίλ Εταιρείας
                </h3>
            </div>
        </div>
        <div class="breadcrumbs-custom-aside">
            <div class="container">
                <ul class="breadcrumbs-custom-path">
                    <li><a routerLink="/home">Αρχική</a></li>
                    <li *ngIf="authService.isValidCompany"><a
                            [routerLink]="['/employer/profile', authService.getCompanyId()]">Επιχείρηση</a></li>
                    <li *ngIf="!authService.isValidCompany" class="active">Ολοκλήρωση Προφίλ</li>
                    <li *ngIf="authService.isValidCompany" class="active">Επεξεργασία Προφίλ</li>
                </ul>
            </div>
        </div>
    </section>

    <section class="section section-md">
        <div class="container" *ngIf="completeEmployerForm">

            <app-alert-message *ngIf="!authService.isValidCompany" [alertOption]="3"></app-alert-message>

            <form [formGroup]="completeEmployerForm" *ngIf="metadata$ | async as metadata">
                <div class="block-form">
                    <div class="rd-mailform" id="submit-resume-form" data-form-output="form-output-global"
                        data-form-type="contact" method="post" action="bat/rd-mailform.php">
                        <h4 id="title">Γενικές Πληροφορίες</h4>
                        <hr>
                        <!-- RD Mailform-->
                        <div class="rd-form rd-mailform form-lg">
                            <div class="row row-40">

                                <!-- name -->
                                <div class="col-md-6">
                                    <div class="form-wrap">
                                        <label class="form-label-outside" for="general-information-name">Επωνυμία
                                            Εταιρείας*</label>
                                        <div class="form-wrap-inner">
                                            <input [attr.disabled]="true" [readonly]="true" placeholder=""
                                                class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid"
                                                id="general-information-name" type="text" name="name"
                                                formControlName="name" data-constraints="@Required"
                                                [ngClass]="{ 'is-invalid': submitted && formControls.name.errors }">
                                            <div *ngIf="submitted && formControls.name.errors" class="text-danger">
                                                <div *ngIf="formControls.name.errors.required">* Υποχρεωτικό πεδίο</div>
                                                <div *ngIf="formControls.name.errors.maxlength">* Ο μέγιστος αριθμός
                                                    χαρακτήρων είναι 50.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- email -->
                                <div class="col-md-6">
                                    <div class="form-wrap">
                                        <label class="form-label-outside" for="general-information-email"
                                            id="general-information-email-label">Email*</label>
                                        <div class="form-wrap-inner">
                                            <input placeholder=""
                                                class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid"
                                                id="general-information-email" type="text" name="email"
                                                formControlName="email" data-constraints="@Required"
                                                [ngClass]="{ 'is-invalid': submitted && (formControls.email.errors || mailExists)}">
                                            <div *ngIf="submitted && (formControls.email.errors || mailExists)"
                                                class="text-danger">
                                                <div *ngIf="formControls.email.errors?.required">* Υποχρεωτικό πεδίο
                                                </div>
                                                <div *ngIf="formControls.email.errors?.maxlength">* Ο μέγιστος αριθμός
                                                    χαρακτήρων είναι 50.</div>
                                                <div *ngIf="mailExists">* Αυτό το email χρησιμοποιείται από κάποιον άλλο
                                                    χρήστη</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- industry -->
                                <div class="col-md-6">
                                    <label class="form-label-outside"
                                        for="general-information-job-category">Κλάδος*</label>
                                    <div class="form-wrap-inner">
                                        <ng-select formControlName="industryId" [items]="industries$ | async"
                                            bindLabel="text" bindValue="id" placeholder="Επίλεξε"
                                            id="general-information-job-category" name="resume-category"
                                            style="width: 100%">
                                        </ng-select>
                                        <div *ngIf="submitted && (formControls.industryId.errors)" class="text-danger">
                                            <div *ngIf="formControls.industryId.errors?.required">* Υποχρεωτικό πεδίο
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- location -->
                                <div class="col-md-6">
                                    <label class="form-label-outside"
                                        for="general-information-location">Τοποθεσία*</label>
                                    <div class="form-wrap-inner">
                                        <ng-select formControlName="locationId" [items]="locations$ | async"
                                            bindLabel="text" bindValue="id" placeholder="Επίλεξε"
                                            id="general-information-location" name="location" style="width: 100%">
                                        </ng-select>
                                        <div *ngIf="submitted && (formControls.locationId.errors)" class="text-danger">
                                            <div *ngIf="formControls.locationId.errors?.required">* Υποχρεωτικό πεδίο
                                            </div>
                                        </div>
                                </div>
                            </div>


                            <!-- description -->
                            <div class="col-sm-12">
                                <label class="form-label-outside" for="general-information-description">Περιγραφή
                                    εταιρείας*</label>
                                <editor id="general-information-description" formControlName="description" [init]="initEditorDesc">
                                </editor>
                                <div *ngIf="submitted && (formControls.description.errors)" class="text-danger">
                                    <div *ngIf="formControls.description.errors?.required">* Υποχρεωτικό πεδίο
                                    </div>
                                </div>
                            </div>

                            <!-- number of employees -->
                            <div class="col-md-6">
                                <div class="form-wrap">
                                    <label class="form-label-outside" for="general-information-email">Αριθμός
                                        Εργαζομένων</label>
                                    <div class="form-wrap-inner">
                                        <input placeholder=""
                                            class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid"
                                            id="general-information-email" type="text" name="numberEmployees"
                                            formControlName="numberEmployees" data-constraints="@Required"
                                            [ngClass]="{ 'is-invalid': submitted && formControls.numberEmployees.errors }">
                                        <div *ngIf="submitted && formControls.numberEmployees.errors"
                                            class="text-danger">
                                            <div *ngIf="formControls.numberEmployees.errors.pattern">* Ο αριθμός
                                                εργαζομένων πρέπει να είναι ένας θετικός ακέραιος αριθμός.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- year_founded
                                <div class="col-md-6">
                                    <label class="form-label-outside" for="general-information-job-category">Έτος Ίδρυσης Έταιρειας</label>
                                    <div class="form-wrap-inner">
                                        <input [attr.disabled]="true" class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid" formControlName="foundation_date" id="general-information-job-category" name="resume-category" [width]="'100%'" [ngClass]="{ 'is-invalid': submitted && formControls.foundation_date.errors }" />
                                    </div>
                                </div> -->

                            <!-- motto -->
                            <div class="col-md-6">
                                <div class="form-wrap">
                                    <label class="form-label-outside" for="general-information-profession">motto</label>
                                    <div class="form-wrap-inner">
                                        <input placeholder=""
                                            class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid"
                                            id="general-information-profession" type="text" name="motto"
                                            formControlName="motto" data-constraints="@Required"
                                            [ngClass]="{ 'is-invalid': submitted && formControls.motto.errors }">
                                        <div *ngIf="submitted && formControls.motto.errors" class="text-danger">
                                            <div *ngIf="formControls.motto.errors.maxlength">* Ο μέγιστος αριθμός
                                                χαρακτήρων είναι 255.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- website -->
                            <div class="col-md-6">
                                <div class="form-wrap">
                                    <label class="form-label-outside" for="general-information-website">Ιστοσελίδα
                                        Εταιρείας</label>
                                    <div class="form-wrap-inner">
                                        <input [attr.disabled]="true" placeholder=""
                                            class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid"
                                            id="general-information-website" type="text" name="website"
                                            formControlName="website" data-constraints="@Required"
                                            [ngClass]="{ 'is-invalid': submitted && formControls.website.errors }">
                                        <div *ngIf="submitted && formControls.website.errors" class="text-danger">
                                            <div *ngIf="formControls.website.errors.pattern">* Το url δεν είναι έγκυρο.
                                            </div>
                                            <div *ngIf="formControls.website.errors.maxlength">* Ο μέγιστος αριθμός
                                                χαρακτήρων είναι 255.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- LinkedIn URL -->
                            <div class="col-md-6">
                                <div class="form-wrap">
                                    <label class="form-label-outside" for="general-information-skills">LinkedIn
                                        URL</label>
                                    <div class="form-wrap-inner">
                                        <input class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid"
                                            id="general-information-skills" formControlName="linkedInUrl" type="text"
                                            name="linkedInUrl"
                                            [ngClass]="{ 'is-invalid': submitted && formControls.linkedInUrl.errors }">
                                        <div *ngIf="submitted && formControls.linkedInUrl.errors" class="text-danger">
                                            <div *ngIf="formControls.linkedInUrl.errors.pattern">* Το url δεν είναι
                                                έγκυρο.</div>
                                            <div *ngIf="formControls.linkedInUrl.errors.maxlength">* Ο μέγιστος αριθμός
                                                χαρακτήρων είναι 255.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Facebook URL -->
                            <div class="col-md-6">
                                <div class="form-wrap">
                                    <label class="form-label-outside" for="general-information-url">Facebook URL
                                    </label>
                                    <div class="form-wrap-inner">
                                        <input class="form-input form-control ng-touched ng-dirty is-invalid ng-invalid"
                                            id="general-information-url" formControlName="facebookUrl" type="text"
                                            name="facebookUrl"
                                            [ngClass]="{ 'is-invalid': submitted && formControls.facebookUrl.errors }">
                                        <div *ngIf="submitted && formControls.facebookUrl.errors" class="text-danger">
                                            <div *ngIf="formControls.facebookUrl.errors.pattern">* Το url δεν είναι
                                                έγκυρο.</div>
                                            <div *ngIf="formControls.facebookUrl.errors.maxlength">* Ο μέγιστος αριθμός
                                                χαρακτήρων είναι 255.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div id="myFiles" *ngIf="companyData.logoId">
                    <div class="row">
                        <div class="col-md-4">
                            <h4>Το Λογότυπο της εταιρείας</h4>
                            <a [href]="fileUrl" (click)="downLoadLogo(companyData.id)"
                                *ngIf="companyData.logoId">{{companyData.logoId}}</a>
                        </div>
                    </div>
                    <hr>
                </div>

                <div id="fileForm">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <label (click)="clearLogoSpan()"
                                class="button button-sm button-primary-outline button-icon button-icon-left form-buttons">
                                <input type="file" name="photo" form="submit-resume-form" accept=".jpg,.png,.gif,.bmp"
                                    (change)="handleLogoInput($event.target.files)"><span
                                    class="icon mdi mdi-account-box"></span><span *ngIf="companyData.logoId">Ενημερωσε
                                    το λογoτυπο της εταιρειας</span><span *ngIf="!companyData.logoId">προσθεσε το
                                    λογoτυπο της εταιρειας </span>
                            </label>
                            <br />
                            <span id="logo"></span>
                        </div>
                    </div>
                    <div *ngIf="logoMessage" class="text-danger">
                        {{ logoMessage }}
                    </div>
                    <hr style="margin-top: 15px;">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <button class="button button-lg button-secondary form-buttons"
                                (click)="completeEmployer()">αποθηκευση</button>
                        </div>
                    </div>
                </div>
        </div>
        </form>
</div>
</section>

</div>
<div class="snackbars" id="form-output-global"></div>